
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActionConfigsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ActionConfigs"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hash"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logConfig"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alertConfig"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cacheConfig"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":142}};
    doc.loc.source = {"body":"fragment ActionConfigsFields on ActionConfigs {\n  id\n  name\n  description\n  hash\n  created\n  updated\n  logConfig\n  alertConfig\n  cacheConfig\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
